module.exports = __webpack_public_path__ + "img/Profil_CS-Flatlinerii.86538c0d.jpg";